import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services.html',
  styleUrl: './services.scss',
})
export class Services {
  services = [
    {
      step: '01',
      icon: 'pi-desktop',
      title: 'Custom Software Development',
      description:
        'End-to-end systems tailored to your business — architecture, APIs, databases, and Azure deployment owned by Trieon Technologies from first commit to production.',
      points: ['Domain-driven design', 'Secure APIs & auth', 'Cloud-ready delivery'],
      tags: ['Enterprise', 'API', '.NET'],
      tone: 'ink',
    },
    {
      step: '02',
      icon: 'pi-globe',
      title: 'Web Application Development',
      description:
        'Responsive Angular web apps with production-grade backends — dashboards, portals, and SaaS experiences that stay fast and maintainable.',
      points: ['Angular + PrimeNG UI', 'Role-based access', 'Realtime-ready stacks'],
      tags: ['Angular', 'PrimeNG', 'Azure'],
      tone: 'teal',
    },
    {
      step: '03',
      icon: 'pi-mobile',
      title: 'Mobile App Development',
      description:
        'Cross-platform mobile apps with Expo and React Native — offline-capable tools and marketplace experiences for iOS and Android.',
      points: ['Offline-first patterns', 'Native device features', 'App store ready builds'],
      tags: ['Expo', 'React Native', 'iOS', 'Android'],
      tone: 'blue',
    },
  ];
}
